import { render, staticRenderFns } from "./picture.vue?vue&type=template&id=5c401c90&scoped=true&"
import script from "./picture.vue?vue&type=script&lang=js&"
export * from "./picture.vue?vue&type=script&lang=js&"
import style0 from "./picture.vue?vue&type=style&index=0&id=5c401c90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c401c90",
  null
  
)

export default component.exports